import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
//primereact
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
//components
import Modal from "../../../components/modal/Modal";
import CreditCard from "../../../components/payment/CreditCard";
import PaymentMethods from "../../../components/payment/PaymentMethods";
import ModalClientData from "../../../components/payment/ModalClientData";
import ModalPixPayment from "../../../components/payment/ModalPixPayment";
//services
import { getDueDate } from "../../../services/CreateAccount/getDueDate";
// import { postRetryPayment } from "../../../services/CreateAccount/postRetryPayment";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
import { useRegisterCompletedContext } from "./RegisterCompletedContext";
// import { getUserOpenPayments } from "../../../services/ClientArea/getUserOpenPayments";

const ModalPayment = ({ visible, setVisible, plan }) => {
  const {
    form,
    formPix,
    bestDay,
    cardState,
    pixClient,
    pixDataQR,
    sortedData,
    setBestDay,
    onSubmitPix,
    optionsDays,
    activeIndex,
    cardMonthly,
    baseDataForm,
    setCardState,
    setPixClient,
    setPixDataQR,
    setSortedData,
    loadingButton,
    paymentMethod,
    setCardMonthly,
    disabledButton,
    setActiveIndex,
    setOptionsDays,
    cardInstallment,
    setBaseDataForm,
    activeIndexModal,
    creditCardClient,
    handleInputFocus,
    setLoadingButton,
    setPaymentMethod,
    visiblePixPayment,
    visibleCreditCard,
    handleInputChange,
    setDisabledButton,
    creditCardSelected,
    setCardInstallment,
    handleMonthlyFocus,
    optionsInstallments,
    handleMonthlyChange,
    setActiveIndexModal,
    setCreditCardClient,
    setVisibleCreditCard,
    setVisiblePixPayment,
    visiblePaymentMethods,
    setCreditCardSelected,
    visibleModalCreditCard,
    setOptionsInstallments,
    handleInstallmentFocus,
    handleRetryPaymentYear,
    handleInstallmentChange,
    handleRetryPaymentMonth,
    setVisiblePaymentMethods,
    setVisibleModalCreditCard,
    handleSelectPaymentMethod,
  } = useRegisterCompletedContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  const steps = [{ label: "Adesão" }, { label: "Mensalidade" }];

  const { data: dueDates } = useQuery({
    queryKey: ["dueDate"],
    queryFn: () => getDueDate(),
  });

  // const { openPayments } = useQuery({
  //   queryKey: ["UserOpenPayments"],
  //   queryFn: () => getUserOpenPayments(),
  //   retry: false,
  //   enabled: plan?.intervals[0]?.interval === "month",
  // });

  // console.log(openPayments);

  useEffect(() => {
    const testDisabledButton = () => {
      const isCardStateEmpty = Object.values(cardState).some(
        (value) => value === ""
      );
      const isPixClientNull = pixClient === null;
      const isCardInstallmentEmpty = Object.values(cardInstallment).some(
        (value) => value === ""
      );
      // const isCardMonthlyEmpty = Object.values(cardMonthly).some(
      //   (value) => value === ""
      // );

      if (
        plan?.interval?.interval === "year" ||
        (plan?.intervals?.length > 0 && plan?.intervals[0]?.interval === "year")
      ) {
        if (
          (isCardStateEmpty && isPixClientNull && isCardInstallmentEmpty) ||
          paymentMethod === null
        ) {
          setDisabledButton(true);
        } else {
          setDisabledButton(false);
        }
      } else {
        if (!isPixClientNull) {
        // if (!isPixClientNull && isCardMonthlyEmpty) {
          setDisabledButton(true);
        } else if (
          (isCardStateEmpty &&
            isPixClientNull &&
            isCardInstallmentEmpty) ||
            // isCardMonthlyEmpty) ||
          paymentMethod === null ||
          !bestDay
        ) {
          setDisabledButton(true);
        } else {
          setDisabledButton(false);
        }
      }
    };
    testDisabledButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cardState,
    cardInstallment,
    cardMonthly,
    pixClient,
    paymentMethod,
    bestDay,
  ]);

  useEffect(() => {
    if (dueDates) {
      const newOptions = dueDates.map((d) => ({
        value: d.due_date,
      }));
      setOptionsDays(newOptions);
    }
  }, [dueDates]);

  return (
    <>
      <Modal
        visible={visible}
        footer={
          plan?.interval?.interval === "year" ||
          (plan?.intervals?.length > 0 &&
            plan?.intervals?.length > 0 &&
            plan?.intervals[0]?.interval === "year") ? (
            <div className="d-flex justify-content-center mt-5">
              <Button
                label="Refazer Pagamento"
                className="rounded-pill"
                icon="fa-solid fa-sync"
                loading={loadingButton}
                disabled={disabledButton}
                onClick={() => handleRetryPaymentYear()}
              />
            </div>
          ) : (
            <div className="d-flex justify-content-center mt-5">
              <Button
                label="Refazer Pagamento"
                className="rounded-pill"
                icon="fa-solid fa-sync"
                loading={loadingButton}
                disabled={disabledButton}
                onClick={() => handleRetryPaymentMonth()}
              />
            </div>
          )
        }
        dynamicTitle={"Refazer Pagamento"}
        onHide={() => setVisible(false)}
        closable={true}
      >
        {plan?.interval?.interval === "year" ||
        (plan?.intervals?.length > 0 &&
          plan?.intervals[0]?.interval === "year") ? (
          <>
            {visiblePaymentMethods && (
              <div className="row text-center justify-content-center">
                <h4>Plano Selecionado</h4>
                <div className="col-md-4 border rounded py-3">
                  <h3>
                    {plan?.name ? plan?.name : plan?.plan.name} -{" "}
                    {plan?.interval?.name
                      ? plan?.interval?.name
                      : plan?.intervals[0]?.name}
                  </h3>
                  {plan?.interval?.interval === "year" ||
                  (plan?.intervals?.length > 0 &&
                    plan?.intervals[0]?.interval === "year") ? (
                    <>
                      <h2 className="text-muted fw-bolder">
                        {formatCurrency(
                          (plan?.interval?.pivot.subscription_fee
                            ? plan?.interval?.pivot.subscription_fee
                            : plan?.intervals[0]?.pivot.subscription_fee) +
                            ((plan?.value_total
                              ? plan?.value_total
                              : plan?.plan.value_total) -
                              (plan?.value_total
                                ? plan?.value_total
                                : plan?.plan.value_total) *
                                (plan?.interval?.pivot.discount_rate >= 0
                                  ? plan?.interval?.pivot.discount_rate
                                  : plan?.intervals[0]?.pivot.discount_rate)) *
                              12
                        )}
                      </h2>
                    </>
                  ) : (
                    <h2 className="text-muted fw-bolder">
                      {formatCurrency(
                        plan?.value_total
                          ? plan?.value_total
                          : plan?.plan.value_total
                      )}
                    </h2>
                  )}
                </div>
                <h4 className="mt-5">
                  Selecione uma forma de pagamento abaixo para refazer o
                  pagamento do plano
                </h4>
              </div>
            )}
            <PaymentMethods
              pix
              card
              installment
              form={form}
              formPix={formPix}
              cardState={cardState}
              onSubmitPix={onSubmitPix}
              paymentMethod={paymentMethod}
              cardInstallment={cardInstallment}
              setPaymentMethod={setPaymentMethod}
              handleInputFocus={handleInputFocus}
              creditCardClient={creditCardClient}
              visibleCreditCard={visibleCreditCard}
              handleInputChange={handleInputChange}
              setCardInstallment={setCardInstallment}
              creditCardSelected={creditCardSelected}
              setActiveIndexModal={setActiveIndexModal}
              setCreditCardClient={setCreditCardClient}
              optionsInstallments={optionsInstallments}
              setVisibleCreditCard={setVisibleCreditCard}
              setCreditCardSelected={setCreditCardSelected}
              visiblePaymentMethods={visiblePaymentMethods}
              handleInstallmentFocus={handleInstallmentFocus}
              handleInstallmentChange={handleInstallmentChange}
              setVisiblePaymentMethods={setVisiblePaymentMethods}
              setVisibleModalCreditCard={setVisibleModalCreditCard}
              handleSelectPaymentMethod={handleSelectPaymentMethod}
            />
          </>
        ) : (
          <>
            <Steps
              model={steps}
              className="mt-2 mb-4"
              activeIndex={activeIndex}
              onSelect={(e) => setActiveIndex(e.index)}
              readOnly={false}
            />

            {activeIndex === 0 && (
              <>
                {visiblePaymentMethods && (
                  <div className="row text-center justify-content-center">
                    <h4>Plano Selecionado</h4>
                    <div className="col-md-4 border rounded py-3">
                      <h3>
                        {plan?.name ? plan?.name : plan?.plan.name} - Taxa de
                        Adesão
                      </h3>
                      <h2 className="text-muted fw-bolder">
                        {formatCurrency(
                          plan?.interval?.pivot.subscription_fee
                            ? plan?.interval?.pivot.subscription_fee
                            : plan?.intervals[0]?.pivot.subscription_fee
                        )}
                      </h2>
                    </div>
                    <h4 className="mt-5">
                      Selecione uma forma de pagamento abaixo para refazer o
                      pagamento da adesão
                    </h4>
                  </div>
                )}
                <PaymentMethods
                  pix
                  card
                  installment
                  form={form}
                  formPix={formPix}
                  cardState={cardState}
                  onSubmitPix={onSubmitPix}
                  paymentMethod={paymentMethod}
                  setCardMonthly={setCardMonthly}
                  cardInstallment={cardInstallment}
                  setPaymentMethod={setPaymentMethod}
                  handleInputFocus={handleInputFocus}
                  creditCardClient={creditCardClient}
                  handleInputChange={handleInputChange}
                  visibleCreditCard={visibleCreditCard}
                  setCardInstallment={setCardInstallment}
                  handleMonthlyFocus={handleMonthlyFocus}
                  creditCardSelected={creditCardSelected}
                  setActiveIndexModal={setActiveIndexModal}
                  setCreditCardClient={setCreditCardClient}
                  optionsInstallments={optionsInstallments}
                  setVisibleCreditCard={setVisibleCreditCard}
                  setCreditCardSelected={setCreditCardSelected}
                  visiblePaymentMethods={visiblePaymentMethods}
                  handleInstallmentFocus={handleInstallmentFocus}
                  handleInstallmentChange={handleInstallmentChange}
                  setVisiblePaymentMethods={setVisiblePaymentMethods}
                  setVisibleModalCreditCard={setVisibleModalCreditCard}
                  handleSelectPaymentMethod={handleSelectPaymentMethod}
                />
              </>
            )}

            {activeIndex === 1 && (
              <>
                <div className="row text-center justify-content-center mb-4">
                  <h4>Plano Selecionado</h4>
                  <div className="col-md-4 border rounded py-3">
                    <h3>
                      {plan?.name ? plan?.name : plan?.plan.name} - Mensalidade
                    </h3>
                    <h2 className="text-muted fw-bolder">
                      {formatCurrency(
                        (plan?.value_total
                          ? plan?.value_total
                          : plan?.plan.value_total) -
                          (plan?.value_total
                            ? plan?.value_total
                            : plan?.plan.value_total) *
                            (plan?.interval?.pivot.discount_rate >= 0
                              ? plan?.interval?.pivot.discount_rate
                              : plan?.intervals[0]?.pivot.discount_rate)
                      )}
                    </h2>
                  </div>
                </div>
                <div className="d-flex flex-column text-center justify-content-center mb-5">
                  <h4>Qual o melhor dia do mês para sua mensalidade?</h4>
                  <SelectButton
                    value={bestDay}
                    onChange={(e) => setBestDay(e.value)}
                    itemTemplate={(option) => {
                      return <h5>{option.value}</h5>;
                    }}
                    optionLabel="value"
                    options={optionsDays}
                  />
                </div>
                {/* {bestDay && (
                  <CreditCard
                    completed={
                      paymentMethod === "card" ||
                      paymentMethod === "installment"
                    }
                    state={cardMonthly}
                    handleInputChange={handleMonthlyChange}
                    handleInputFocus={handleMonthlyFocus}
                    onClickData={() => {
                      setVisibleModalCreditCard(true);
                      setActiveIndexModal(0);
                    }}
                    onClickAddress={() => {
                      setVisibleModalCreditCard(true);
                      setActiveIndexModal(1);
                    }}
                    clientData={
                      creditCardClient?.data && creditCardClient?.data
                    }
                    clientAddress={
                      creditCardClient?.address && creditCardClient?.address
                    }
                  />
                )} */}
              </>
            )}
          </>
        )}
      </Modal>

      <ModalClientData
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        setActiveIndex={setActiveIndexModal}
        setVisible={setVisibleModalCreditCard}
        creditCardClient={creditCardClient}
        setCreditCardClient={setCreditCardClient}
        baseDataForm={baseDataForm}
      />

      <ModalPixPayment
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        onContinue={() => navigate("/success",{state: {pixPayment: true, idPayment: pixDataQR.id ? pixDataQR.id : ""}})}
      />
    </>
  );
};

export default ModalPayment;
